import React from "react";
import { MdSend } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";
import Image01 from "../assets/svg/projectProfile.svg";
import "./chatMessages.css";

const ChatMessages = () => {
  return (
    <div className="w-[65%] h-full">
      <p className="text-xl font-bold pb-2">Messages</p>

      <div className="border-2 rounded-xl mt-3 mb-5 h-[90%] flex flex-col justify-between">
        <div className="border-b-2 py-2 mb-3 px-5 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <img src={Image01} alt="" />
            <div>
              <p className="text-sm font-semibold">Alex</p>
              <div className="flex items-center gap-1">
                <p className="text-xs font-medium">Online</p>
                <div className="w-[5px] h-[5px] rounded-full bg-[#0dc143]" />
              </div>
            </div>
          </div>
        </div>
        <div className="pt-2  h-[69%] overflow-scroll scrollbar-hide">
          <div className="flex justify-start">
            <div className="mr-52 px-5">
              <p className="text-end text-sm pb-2">1 April 12:00</p>
              <div className="flex gap-3">
                <img src={Image01} alt="" className="mt-7" />
                <div className="mb-7">
                  <p className="bg-[#eceef1] py-3 px-1 text-sm font-medium relative designs ml-4">
                    Hi, That is great! Let me give you a call and we'll discuss
                    about all the details.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <div className="ml-52 px-5 mb-5">
              <p className="text-start text-sm pb-2">1 April 12:00</p>
              <div className="flex gap-3">
                <div>
                  <p className="bg-primary text-white py-3 px-1 text-sm font-medium  relative design mr-2">
                    Hi, Alex!, It's nice meeting you!
                    <br />
                    I'd like to hire a walker and you are perfect one for me,
                    Can you help me out
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-start">
            <div className="mr-52 px-5">
              <p className="text-end text-sm pb-2">12:30</p>
              <div className="flex gap-3">
                <img src={Image01} alt="" className="mt-7" />
                <div className="mb-7">
                  <p className="bg-[#eceef1] py-3 px-1 text-sm font-medium relative designs ml-4">
                    Hi, That is great! Let me give you a call and we'll discuss
                    about all the details.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <div className="ml-52 px-5 mb-5">
              <p className="text-start text-sm pb-2">12:30</p>
              <div className="flex gap-3">
                <div>
                  <p className="bg-primary text-white py-3 px-1 text-sm font-medium  relative design mr-2">
                    Okay, I'm waiting for a call
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between py-3 px-5  border-t-2">
          <div className="bg-[#f5f5f5] p-3 rounded-md cursor-pointer">
            <AiOutlinePlus className="text-primary" />
          </div>
          <input
            type="text"
            placeholder="Hi Hope you are doing well"
            className="w-[60%] focus:outline-none bg-[#f5f5f5] p-3 w-[85%] rounded-lg"
          />
          <div className="bg-[#f5f5f5] p-3 rounded-md cursor-pointer">
            <MdSend className="text-primary" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMessages;
